import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page contacts-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "glass-card contacts-intro" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "contacts-email-block" }
const _hoisted_8 = { class: "contacts-email-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eyebrowContacts), 1),
      _createElementVNode("h1", {
        innerHTML: _ctx.jsonData.contacts
      }, null, 8, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "contacts-text",
        innerHTML: _ctx.jsonData.contactsText
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.jsonData.contactsWriteDirectly), 1),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        class: "contacts-email-btn",
        href: "https://mail.google.com/mail/?view=cm&fs=1&to=jumbada.sales@gmail.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        _createElementVNode("span", { class: "email-icon" }, "✉"),
        _createTextVNode(" jumbada.sales@gmail.com ")
      ], -1))
    ])
  ]))
}